import "./App.css";
import ExperienceSection from "./componenets/experience/ExperienceSection";
import HeroSection from "./componenets/herosection/HeroSection";
import Navbar from "./componenets/navbar/Navbar";
import { useState, useEffect } from "react";
import ProjectsSection from "./componenets/projects/ProjectsSection";
import ContactSection from "./componenets/contact/ContactSection";

function App() {
  // handle what happens when you click a navbar item
  const navbarHandleOnClick = (section) => {
    if (section === "/home") {
      const heroSection = document.getElementById("hero-section");
      heroSection?.scrollIntoView({ behavior: "smooth" });
    } else if (section === "/experience") {
      const experienceSection = document.getElementById("experience-section");
      experienceSection?.scrollIntoView({ behavior: "smooth" });
    } else if (section === "/projects") {
      const experienceSection = document.getElementById("projects-section");
      experienceSection?.scrollIntoView({ behavior: "smooth" });
    } else if (section === "/contacts") {
      const experienceSection = document.getElementById("contacts-section");
      experienceSection?.scrollIntoView({ behavior: "smooth" });
    }
  };

  //get the scroll position when you scroll to animate navbar
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Get vertical scroll position
      setScrollPosition(scrollY);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up on component unmount
    };
  }, []);

  return (
    <div className="App">
      {
        <Navbar
          scrollPosition={scrollPosition}
          handleOnClick={navbarHandleOnClick}
        />
      }
      <HeroSection />
      <ExperienceSection />
      <ProjectsSection />
      <ContactSection />
    </div>
  );
}

export default App;
